function NotFoundPage() {
  return (
    <div className="voices-404-wrapper min-vh-100 d-flex flex-column justify-content-between p-3 p-md-5 position-relative overflow-hidden">
      <div className="bg-map-overlay position-absolute top-0 start-0 w-100 h-100"></div>

      <div className="chatbridge-bg-network position-absolute"></div>

      <header className="w-100 px-3 px-md-4 py-2 d-flex align-items-center justify-content-center position-relative z-index-2">
        <a href="https://voices.com.mx/" rel="noopener noreferrer">
          <img
            src="/assets/media/logos/voices-gnl-dark.png"
            alt="Voices GNL"
            className="voices-logo-top"
          />
        </a>
      </header>

      <main className="container my-auto position-relative z-index-2 py-4 py-md-5">
        <div className="row align-items-center justify-content-center text-center text-md-start gy-5">
          <div className="col-12 col-md-5 d-flex flex-column align-items-center justify-content-center border-md-end-custom explicit-fluid-block">
            <span className="voices-oops text-lowercase mb-0">oops!</span>
            <h1 className="voices-huge-404 my-0">404</h1>
            <p className="voices-subtitle-left text-white text-center mt-2">
              No encontramos la <span className="text-highlight">página</span> que buscas.
            </p>
          </div>

          <div className="col-12 col-md-7 ps-md-5">
            <p className="voices-description-text text-white-50 lh-lg mb-4 mx-auto mx-md-0">
              Lamentamos informarte que la página que estás buscando no existe o ha sido removida.
              Te invitamos a regresar a la página principal o a continuar navegando a través del
              siguiente enlace.
            </p>
          </div>
        </div>
      </main>

      <footer className="w-100 px-3 px-md-4 py-2 d-flex flex-column flex-sm-row align-items-center justify-content-between text-white fs57 position-relative z-index-2 gap-2">
        <span>© Voices 2026.</span>
        <span>Todos los derechos reservados.</span>
      </footer>
    </div>
  );
}

export default NotFoundPage;
